import React from 'react';
import SanitizedMarkdown from 'react-scale/components/design-system/SanitizedMarkdown';

const description = `
### Description:
Exclude Workers from Batch and Redo Tasks

Use cases (why)
- A tasker may be spamming in a way that isn't detected by our automated checks, so we want to disable them manually
- It's fairly common that a tasker might have completely reasonable answers, but Bee would not like their answers because of low standard deviation or something. In this case, we want to keep their pay and have them keep working, but remove their work from the current batch and move them to another batch.

Changes (how)
- Prevents tasks from this batch from being served to the selected taskers
- Mark the taskers' attempts from this batch to be excluded
- Recalls affected tasks that have already reached consensus back to attempt

##### Author: Rashid Lasker
---
`;

const link = `
  This tool is provided in an already existing corp tool available [here](/corp/dynamic_corp?name=exclude-workers-from-batch)
`;

const BlacklistTaskers = () => {
  return (
    <div className="root">
      <section>
        <SanitizedMarkdown text={description} />
      </section>

      <section>
        <SanitizedMarkdown text={link} />
      </section>
    </div>
  );
};

export default BlacklistTaskers;
